export type FactorType = 'application' | 'email';

export enum Factor {
    application = 'application',
    email = 'email',
};

export type FactorWithOtpSendableType = 'email';

export enum FactorWithOtpSendable {
    email = 'email',
};

export type FactorStatusType = 'Enabled' | 'Disabled';

export enum FactorStatus {
    enabled = 'Enabled',
    disabled = 'Disabled',
}

export type FactorVerificationStatusType = 'Verified' | 'NotVerified';

export enum FactorVerificationStatus {
    verified = 'Verified',
    notVerified = 'NotVerified',
}